module.exports = __webpack_public_path__ + "static/media/rebirth_sample_3.6da409d0.jpg";